import { ServiceEcommerce2 } from '@app/services/ServiceEcommerce';
import { useDataPreparationFastOrder } from '@entities/Product';
import { fastOrderActions, TypeTemplateFastOrder } from '@features/fastOrder';
import { useAppDispatch } from '@redux/hooks';
import { useEffect, useState } from 'react';

export const useClickOnTheMapButtonToPickUpHere = (): { shopId: number; setShopId: (payload) => void } => {
  const [shopId, setShopId] = useState<number>(null);
  const dispatch = useAppDispatch();
  const productData = useDataPreparationFastOrder();

  useEffect(() => {
    function onClickInBalloon(e) {
      if (e.target.matches('.order-map-button')) {
        const shopId = parseInt(e.target?.attributes['data-id']?.nodeValue);
        shopId && setShopId(shopId);

        ServiceEcommerce2.setScenario('Сценарий 3');
        ServiceEcommerce2.scenario(e.target.innerText.trim());

        dispatch(
          fastOrderActions.setOpenModal({
            productData,
            template: TypeTemplateFastOrder.pickUpStore,
            currentShopId: shopId,
          }),
        );
      }
    }
    window.addEventListener('click', onClickInBalloon);
    return () => window.removeEventListener('click', onClickInBalloon);
  }, []);

  return { shopId, setShopId };
};
